import { NgModule, CUSTOM_ELEMENTS_SCHEMA } from "@angular/core";
import { AppCommonModule } from "@common/common.module";

import { CallBackMobileComponent } from "./call-back-mobile/call-back-mobile.component";
import { LocateUsMobileComponent } from "./locate-us-mobile/locate-us-mobile.component";
import { WriteUsMobileComponent } from "./write-us-mobile/write-us-mobile.component";

import { LocateUsComponent } from "./locate-us/locate-us.component";
import { WriteUsComponent } from "./write-us/write-us.component";
import { CallBackComponent } from "./call-back/call-back.component";
import { RegulatoryMessageDisplayComponent } from "./regulatory-message-display/regulatory-message-display.component";
import { TollFreeNotificationComponent } from "./toll-free-notification/toll-free-notification.component";

@NgModule({
  declarations: [
    WriteUsComponent,
    CallBackComponent,
    LocateUsComponent,
    CallBackMobileComponent,
    LocateUsMobileComponent,
    WriteUsMobileComponent,
    RegulatoryMessageDisplayComponent,
    TollFreeNotificationComponent
  ],
  imports: [AppCommonModule],
  exports: [
    WriteUsComponent,
    CallBackComponent,
    LocateUsComponent,
    CallBackMobileComponent,
    LocateUsMobileComponent,
    WriteUsMobileComponent,
    RegulatoryMessageDisplayComponent,
    TollFreeNotificationComponent
  ],
})
export class PopUpsModule {}
